



































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { EBatchStatus, EOrigin, EStatementStatuses, EUserPermissions, IFacility, IUser, EFacilityBlockableFeatures, getIdFromEntityField } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Tabs from '@/components/layout/Tabs.vue'
import { StatementModule } from '@/store/modules/statement.module'
import { FacilityModule } from '@/store/modules/facility.module'
import {
  DO_NOT_BILL_STATUSES,
  STATEMENT_MAILED_STATUSES,
  STATEMENT_STATUSES_LABEL_MAP,
  STATEMENT_UNMAILED_STATUSES
} from '@/constants'
import Api from '@/api'
import { User } from '@/classes/User'
import UpdateStatementModal from '@/views/app/management/mailings/components/UpdateStatementModal.vue'
import ResidentLabel from '@/components/labels/ResidentLabel.vue'
import Card from '@/components/Card.vue'
import GoBack from '@/components/GoBack.vue'
import CircleChartWithDescriptions from '@/components/chart/CircleChartWithDescriptions.vue'
import Confirm from '@/components/Confirm.vue'
import StatementsMailSuccessModal from './components/StatementsMailSuccessModal.vue'
import StatementsMailCompleteModal from './components/StatementsMailCompleteModal.vue'
import { BatchModule } from '@/store/modules/batch.module'
import ModalV2 from '@/components/modals/ModalV2.vue'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import DownloadModal from './components/DownloadModal.vue'
import { makeErrorNotification } from '@/utils/notification'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { isFacilityFeatureBlocked } from '@/utils/facility/facilityFeatures'

@Component({
  components: {
    ModalV2,
    StatementsMailCompleteModal,
    StatementsMailSuccessModal,
    Confirm,
    CircleChartWithDescriptions,
    GoBack,
    Card,
    ResidentLabel,
    UpdateStatementModal,
    Icon,
    DateTimeLabel,
    Tabs,
    ButtonDownloadReport,
    DownloadModal,
    LoaderWrapper
  }
})
export default class ManagementStatementsBatch extends Vue {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  batchModuleInstance: BatchModule = getModule(BatchModule, this.$store)
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EStatementStatuses = EStatementStatuses
  user: User = Api.getUser() as User
  doNotBillStatuses: EStatementStatuses[] = DO_NOT_BILL_STATUSES
  sentMailResult: { deliverToRoom: number, printedStatementUser: IUser } | null = null

  shouldShowStatementsMailSuccessMessage: boolean = false
  shouldShowStatementsMailCompleteMessage: boolean = false
  showDownloadModal: boolean = false
  showUpdateStatementsModal: boolean = false
  isUpdatingStatements: boolean = false
  shouldConfirmMail2: boolean = false
  isMailing: boolean = false
  isLoading: boolean = false
  get confirmMessage () {
    if (!this.mailStatementsSum) {
      return 'There are no statements to mail out.'
    }
    if (this.selectedBatch && Number(this.selectedBatch.notReadyCount) === 0) {
      return `Your batch is ready to go! Are you ready to send ${this.mailStatementsSum} statement(s)?`
    }
    return `Are you sure you would like to send ${this.mailStatementsSum} statement(s)?`
  }

  get confirmContent () {
    if (!this.mailStatementsSum) {
      return ''
    }
    return `
      <p><b>${this.mailStatements.mailed}</b> statements will be mailed.</p>
      <p><b>${this.mailStatements.paperless}</b> statements will be emailed.</p>
      <p><b>${this.mailStatements.deliverToRoom}</b> statements will be delivered to resident’s room by ${this.mailStatementsUser}</p>
     `
  }

  get isUnmailedTab () {
    return this.$route.name === 'management-mailings-statements-batch-unmailed'
  }

  get showReviewBtn () {
    return this.selectedBatch && this.selectedBatch.notReadyCount > 0
  }

  get updateCompleteBatchPermission () {
    const isBatchNotComplete = this.selectedBatch.status !== EBatchStatus.COMPLETE
    return isBatchNotComplete || this.user.hasPermissionFor(EUserPermissions.ALLOW_UPDATE_COMPLETED_BATCH)
  }

  get confirmSubMessage () {
    if (!this.mailStatementsSum) {
      return ''
    }
    return 'You will not be able to cancel this action.'
  }

  get tabs () {
    return [
      {
        key: 'management-mailings-statements-batch-unmailed',
        value: { name: 'management-mailings-statements-batch-unmailed' },
        content: 'Unmailed'
      },
      {
        key: 'management-mailings-statements-batch-mailed',
        value: { name: 'management-mailings-statements-batch-mailed' },
        content: 'Mailed'
      }
    ]
  }

  get dashboardUnmailedData () {
    return [
      {
        value: this.dashboardStatistics[this.EStatementStatuses.READY_TO_MAIL] + this.dashboardStatistics[this.EStatementStatuses.READY_TO_EMAIL] + this.dashboardStatistics[this.EStatementStatuses.READY_TO_PRINT],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.READY_TO_MAIL],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.NEEDS_FIX],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.NEEDS_FIX],
        color: 'var(--status-incomplete-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.NEEDS_REVIEW],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.NEEDS_REVIEW],
        color: 'var(--status-error-color)'
      },
      {
        value: (
          this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL] +
          this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_NEGATIVE] +
          this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_ZERO] +
          this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_PERMANENTLY] +
          this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_CONTROL] +
          this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_RETURNED]
        ),
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.DO_NOT_BILL],
        color: 'var(--status-progress-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.RETURNED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.RETURNED],
        color: 'var(--status-error-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.EMAIL_RETURNED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.EMAIL_RETURNED],
        color: 'var(--status-error-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_RETURNED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.DO_NOT_BILL_RETURNED],
        color: 'var(--status-error-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.DO_NOT_BILL_EMAIL_RETURNED],
        color: 'var(--status-error-color)'
      }
    ]
  }

  get dashboardMailedData () {
    return [
      {
        value: this.dashboardStatistics[this.EStatementStatuses.DELIVERED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.DELIVERED],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.REROUTED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.REROUTED],
        color: 'var(--status-incomplete-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.IN_TRANSIT],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.IN_TRANSIT],
        color: 'var(--status-info-color)'
      }, {
        value: this.dashboardStatistics[this.EStatementStatuses.IN_PROCESS],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.IN_PROCESS],
        color: 'var(--status-progress-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.IN_LOCALAREA],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.IN_LOCALAREA],
        color: 'var(--status-default-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.PRINTED_LOCALLY],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.PRINTED_LOCALLY],
        color: 'var(--status-info-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.EMAILED],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.EMAILED],
        color: 'var(--status-success-color)'
      },
      {
        value: this.dashboardStatistics[this.EStatementStatuses.PENDING],
        text: STATEMENT_STATUSES_LABEL_MAP[this.EStatementStatuses.PENDING],
        color: 'var(--status-info-color)'
      }
    ]
  }

  get facilitiesList (): IFacility[] {
    return this.$store.state.facility.facilities || []
  }

  get mailStatements () {
    return this.$store.state.statement.mailStatements
  }

  get mailStatementsUser () {
    if (!this.$store.state.statement.mailStatements.printedStatementUser) {
      return ''
    }
    const user = this.$store.state.statement.mailStatements.printedStatementUser
    return `${user && user.firstName ? user.firstName : ''} ${user && user.lastName ? user.lastName : ''}`
  }

  get mailStatementsSum () {
    return this.mailStatements ? this.mailStatements.deliverToRoom + this.mailStatements.paperless + this.mailStatements.mailed : 0
  }

  get selectedBatch () {
    return this.$store.state.batch.selectedBatch
  }

  get selectedBatchFacility () {
    const batchFacilityId = getIdFromEntityField(this.selectedBatch.facility)
    return this.facilitiesList.find(f => f.id === batchFacilityId)
  }

  get batchID () {
    return this.$route.params.id
  }

  get dashboardStatistics () {
    return this.$store.state.batch.statementsBatchDashboardStatistics
  }

  beforeMount () {
    if (this.$route.name === 'management-mailings-batch') {
      this.$router.push({ name: 'management-mailings-statements-batch-unmailed' })
    }
  }

  async mounted () {
    this.$eventBus.$on('downloading', this.downloadingStatus)
    this.$eventBus.$on('hasCorruptFiles', this.doMakeErrorNotification)
    await this.facilityModuleInstance.getFacilityList({})
    await Promise.all([
      this.facilityModuleInstance.fetchFacilitiesActivePayerTypesMap(this.facilitiesList.map(facility => facility.id as number)),
      this.batchModuleInstance.getStatementsBatchDashboardStatistics(this.batchID)
    ])
  }

  beforeDestroy () {
    this.batchModuleInstance.resetStatistics()
  }

  get mailedStatusesCount () {
    if (this.dashboardStatistics) {
      let count = 0
      Object.values(STATEMENT_MAILED_STATUSES).forEach((mailedStatus: EStatementStatuses) => {
        count += this.dashboardStatistics[mailedStatus]
      })
      return count.toString()
    }
    return 0
  }

  get unmailedStatusesCount () {
    if (this.dashboardStatistics) {
      let count = 0
      Object.values(STATEMENT_UNMAILED_STATUSES).forEach((unmailedStatus: EStatementStatuses) => {
        count += this.dashboardStatistics[unmailedStatus]
      })
      return count.toString()
    }
    return 0
  }

  get statementListTotal () {
    return this.$store.state.statement.statementListTotal
  }

  get filteredStatementListCount () {
    return this.$store.state.statement.statementListTotal
  }

  toggleDownload (show: boolean) {
    this.showDownloadModal = show
  }

  downloadingStatus (status: boolean) {
    this.isLoading = status
  }

  doMakeErrorNotification (message: string) {
    makeErrorNotification(this, message)
  }

  async mail () {
    if (!this.user.hasPermissionFor(EUserPermissions.MAIL_STATEMENTS)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Mail Statements`,
        icon: 'warning'
      })
    }
    this.isMailing = true
    this.closeConfirmMail()
    const response: any = await this.statementModuleInstance.sendStatementsBatchMails(this.batchID)
    if (response !== 'Fail') {
      // this.$eventBus.$emit('notify', {
      //   color: 'var(--status-success-color)',
      //   message: 'Process Started',
      //   header: `Statements sending Via Mail`,
      //   icon: 'check'
      // })
      // @ts-ignore
      await this.$refs.statements.fetchStatements()
      await this.batchModuleInstance.getStatementsBatchDashboardStatistics(this.batchID)
      this.sentMailResult = response
      if (this.dashboardStatistics[EStatementStatuses.NEEDS_FIX] === 0 &&
        this.dashboardStatistics[EStatementStatuses.NEEDS_REVIEW] === 0) {
        // this.shouldShowStatementsMailCompleteMessage = true
        this.shouldShowStatementsMailSuccessMessage = true
      } else {
        this.shouldShowStatementsMailSuccessMessage = true
      }
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Process Failed',
        header: `Statements sending Via Mail`,
        icon: 'warning'
      })
    }
    this.isMailing = false
    this.$forceUpdate()
  }

  openSendMailConfirm () {
    this.statementModuleInstance.fetchMailStatements(this.batchID)
    this.shouldConfirmMail2 = true
  }

  closeConfirmMail () {
    this.shouldConfirmMail2 = false
    this.statementModuleInstance.clearMailStatements()
  }

  closeStatementsMailCompleteModal () {
    this.shouldShowStatementsMailCompleteMessage = false
  }

  closeStatementsMailSuccessModal () {
    this.shouldShowStatementsMailSuccessMessage = false
  }

  goToPage (options: any) {
    this.$locationManager.rememberAndGoTo(options)
  }

  async openUpdateStatementsModal () {
    if (this.selectedBatch.facility.origin === EOrigin.PCC) {
      this.isUpdatingStatements = true
      const response = await this.statementModuleInstance.fetchBatchStatements({
        batchId: this.batchID,
        isUpdating: true
      })
      this.isUpdatingStatements = false
      this.updateStatements(response)
      return
    }
    if (this.selectedBatch.facility.origin === EOrigin.NCS) {
      this.isUpdatingStatements = true
      const response = await this.statementModuleInstance.fetchBatchNCSStatements({
        batchId: this.batchID,
        isUpdating: true
      })
      this.isUpdatingStatements = false
      this.updateStatements(response)
      return
    }
    this.showUpdateStatementsModal = true
  }

  updateStatements (response: any) {
    this.showUpdateStatementsModal = false
    if (response === 'OK') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Process Started',
        header: `Statements Updating...`,
        icon: 'check'
      })
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-error-color)',
      message: 'Process Failed',
      header: `Statements Updating...`,
      icon: 'warning'
    })
  }

  get isStatementGenAndMailBlocked () {
    return !this.selectedBatchFacility || isFacilityFeatureBlocked(this.selectedBatchFacility, EFacilityBlockableFeatures.MailAndGenStatements)
  }
}
